// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type CampaignPatchMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  input: PrivateSchemaTypes.CampaignPatchInput;
}>;


export type CampaignPatchMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { patch?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignModel' }
        & Pick<PrivateSchemaTypes.CampaignModel, 'id'>
      )> }
    )> }
  )> }
);

export type SetCampaignTrackLinksMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  trackLinks: PrivateSchemaTypes.Scalars['Boolean'];
}>;


export type SetCampaignTrackLinksMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id'>
      & { setTrackLinks?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'CampaignModelAsAdminQueries' }
        & Pick<PrivateSchemaTypes.CampaignModelAsAdminQueries, 'id' | 'track_links'>
      )> }
    )> }
  )> }
);

export type ArchiveCampaignMutationVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type ArchiveCampaignMutation = (
  { __typename?: 'Mutation' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerMutations' }
    & { campaign?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'CampaignModelAsAdminMutations' }
      & Pick<PrivateSchemaTypes.CampaignModelAsAdminMutations, 'id' | 'archive'>
    )> }
  )> }
);


export const CampaignPatchDocument = gql`
    mutation campaignPatch($id: PositiveInt!, $input: CampaignPatchInput!) {
  admin {
    campaign(id: $id) {
      id
      patch(input: $input) {
        id
      }
    }
  }
}
    `;
export type CampaignPatchMutationFn = Apollo.MutationFunction<CampaignPatchMutation, CampaignPatchMutationVariables>;

/**
 * __useCampaignPatchMutation__
 *
 * To run a mutation, you first call `useCampaignPatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCampaignPatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [campaignPatchMutation, { data, loading, error }] = useCampaignPatchMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCampaignPatchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CampaignPatchMutation, CampaignPatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CampaignPatchMutation, CampaignPatchMutationVariables>(CampaignPatchDocument, options);
      }
export type CampaignPatchMutationHookResult = ReturnType<typeof useCampaignPatchMutation>;
export type CampaignPatchMutationResult = Apollo.MutationResult<CampaignPatchMutation>;
export type CampaignPatchMutationOptions = Apollo.BaseMutationOptions<CampaignPatchMutation, CampaignPatchMutationVariables>;
export const SetCampaignTrackLinksDocument = gql`
    mutation setCampaignTrackLinks($id: PositiveInt!, $trackLinks: Boolean!) {
  admin {
    campaign(id: $id) {
      id
      setTrackLinks(trackLinks: $trackLinks) {
        id
        track_links
      }
    }
  }
}
    `;
export type SetCampaignTrackLinksMutationFn = Apollo.MutationFunction<SetCampaignTrackLinksMutation, SetCampaignTrackLinksMutationVariables>;

/**
 * __useSetCampaignTrackLinksMutation__
 *
 * To run a mutation, you first call `useSetCampaignTrackLinksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCampaignTrackLinksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCampaignTrackLinksMutation, { data, loading, error }] = useSetCampaignTrackLinksMutation({
 *   variables: {
 *      id: // value for 'id'
 *      trackLinks: // value for 'trackLinks'
 *   },
 * });
 */
export function useSetCampaignTrackLinksMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetCampaignTrackLinksMutation, SetCampaignTrackLinksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetCampaignTrackLinksMutation, SetCampaignTrackLinksMutationVariables>(SetCampaignTrackLinksDocument, options);
      }
export type SetCampaignTrackLinksMutationHookResult = ReturnType<typeof useSetCampaignTrackLinksMutation>;
export type SetCampaignTrackLinksMutationResult = Apollo.MutationResult<SetCampaignTrackLinksMutation>;
export type SetCampaignTrackLinksMutationOptions = Apollo.BaseMutationOptions<SetCampaignTrackLinksMutation, SetCampaignTrackLinksMutationVariables>;
export const ArchiveCampaignDocument = gql`
    mutation archiveCampaign($id: PositiveInt!) {
  admin {
    campaign(id: $id) {
      id
      archive
    }
  }
}
    `;
export type ArchiveCampaignMutationFn = Apollo.MutationFunction<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;

/**
 * __useArchiveCampaignMutation__
 *
 * To run a mutation, you first call `useArchiveCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCampaignMutation, { data, loading, error }] = useArchiveCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>(ArchiveCampaignDocument, options);
      }
export type ArchiveCampaignMutationHookResult = ReturnType<typeof useArchiveCampaignMutation>;
export type ArchiveCampaignMutationResult = Apollo.MutationResult<ArchiveCampaignMutation>;
export type ArchiveCampaignMutationOptions = Apollo.BaseMutationOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;